<sc-flex [stretchContent]="true">

    <ng-container [formGroup]="modeSelectionFormGroup">
        <mat-button-toggle-group formControlName="mode" name="mode">
            <mat-button-toggle value="complex"><sc-icon iconClass="fa-desktop"></sc-icon></mat-button-toggle>
            <mat-button-toggle value="assign"><sc-icon iconClass="fa-truck-container"></sc-icon></mat-button-toggle>
            <mat-button-toggle value="control"><sc-icon iconClass="fa-forklift"></sc-icon></mat-button-toggle>
        </mat-button-toggle-group>
    </ng-container>

    <sc-content-spacer></sc-content-spacer>

    <ng-container *ngFor="let structure of structures, let i = index">
        <sc-content-spacer *ngIf="i>0"></sc-content-spacer>
        <app-sac-header-tab [structure]="structure" [selected]="currentStructure === structure"
            (close)="closeStructure($event)" (select)="selectStructure($event)"></app-sac-header-tab>
    </ng-container>

    <sc-content-spacer [grow]="true"></sc-content-spacer>

    <button mat-icon-button class="options-icon-button" (click)="addStructure()">
        <sc-icon iconClass="fa-plus"></sc-icon>
    </button>

    <sc-content-spacer></sc-content-spacer>

    <button mat-icon-button class="options-icon-button" [matMenuTriggerFor]="appMenu">
        <sc-icon iconClass="fa-cog menu-icon"></sc-icon>
    </button>

    <sc-content-spacer *ngIf="sacClientContext.standaloneMode"></sc-content-spacer>
    <ac-context-language-selection *ngIf="sacClientContext.standaloneMode"></ac-context-language-selection>

    <div class="options-menu">
        <mat-menu #appMenu="matMenu" class="sac-option-menu" [formGroup]="settingsFormGroup">
            <div mat-menu-item (click)="$event.stopPropagation();">
                <mat-checkbox name="highlightNewTransports" formControlName="highlightNewTransports">
                    {{'highlight transports'
                    |translate:['tmc-yard.widgets.sac-client.sac-header.option.highlight-available-transports',translationService.language]}}
                </mat-checkbox>
            </div>
            <div mat-menu-item (click)="$event.stopPropagation();">
                <mat-checkbox name="notificationsEnabled" formControlName="notificationsEnabled">
                    {{'play notification sound' |
                    translate:['tmc-yard.widgets.sac-client.sac-header.option.play-notification-sound',translationService.language]}}
                </mat-checkbox>
            </div>
        </mat-menu>
    </div>

    <sc-content-spacer *ngIf="showOptionConnectionDialog"></sc-content-spacer>
    <button mat-icon-button class="options-icon-button" (click)="showTransportOptionsGcConnectionDialog()"
        *ngIf="showOptionConnectionDialog">
        <sc-icon iconClass="fa-qrcode"></sc-icon>
    </button>

</sc-flex>
<sc-content-spacer [vertical]="true"></sc-content-spacer>
